import React, { useEffect, useState } from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import toast from "react-hot-toast";
import "./ContactQueries.css";

import {
  getAllContactQueries,
  deleteContactQueryById,
} from "../../api/contactQueryApi";

import Pagination from "../../components/MiniComponents/Pagination";

const ContactQueries = () => {
  const [openMenu, setOpenMenu] = useState(null);
  const [queries, setQueries] = useState([]);
  const [selectedQuery, setSelectedQuery] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");

  // 🔹 Fetch queries
  const fetchQueries = async () => {
    try {
      const res = await getAllContactQueries(page, 10, search);
      setQueries(res?.data?.supports || []);
      setTotalPages(res?.data?.totalPages || 1);
      console.log("fdgjhk", res);
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch queries");
    }
  };

  useEffect(() => {
    fetchQueries();
  }, [page, search]);

  // 🔹 View
  const handleView = (item) => {
    setSelectedQuery(item);
    setOpenMenu(null);
  };

  // 🔹 Delete
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this query?")) return;

    try {
      await deleteContactQueryById(id);
      toast.success("Query deleted successfully");
      fetchQueries();
      setOpenMenu(null);
    } catch (err) {
      console.error(err);
      toast.error("Delete failed");
    }
  };

  const getMessageSnippet = (msg) =>
    msg ? msg.split(" ").slice(0, 5).join(" ") + " ..." : "_";

  return (
    <div className="contact-container">
      <div className="contact-header">
        <h3>Contact Queries</h3>
        <p>View and manage user queries</p>
      </div>

      <div className="table-wrapper">
        <div className="table-header">
          <div>SRN</div>
          <div>Email</div>
          <div>Phone</div>
          <div>Subject</div>
          <div>Message</div>
          <div>Image</div>
          {/* <div>Action</div> */}
        </div>

        <div className="table-body">
          {queries.map((item, index) => (
            <div key={item._id} className="table-row">
              <div>{index + 1}</div>

              <div>{item.email || "_"}</div>
              <div>{item.phone || "_"}</div>
              <div>{item.issue}</div>
              <div onClick={() => handleView(item)}>
                {getMessageSnippet(item.description)}
              </div>
              {/* <div>
                <img style={{ height: "20px" }} src={item.image} alt="image" />
              </div> */}
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  style={{
                    width: "40px",
                    height: "40px",
                    objectFit: "cover",
                    borderRadius: "6px",
                  }}
                  src={item.image}
                  alt="img"
                />
              </div>

              {/* <div className="actions">
                <button
                  className="action-btn"
                  onClick={() =>
                    setOpenMenu(openMenu === item._id ? null : item._id)
                  }
                >
                  <BsThreeDotsVertical />
                </button>

                {openMenu === item._id && (
                  <div className="dropdownn">
                    <button onClick={() => handleView(item)}>View</button>
                    <button onClick={() => handleDelete(item._id)}>
                      Delete
                    </button>
                  </div>
                )}
              </div> */}
            </div>
          ))}

          {queries.length === 0 && (
            <div className="no-data">No queries found</div>
          )}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginRight: "10px",
            marginBottom: "10px",
          }}
        >
          {totalPages > 1 && (
            <Pagination
              currentPage={page}
              totalPages={totalPages}
              onPageChange={(p) => setPage(p)}
            />
          )}
        </div>
      </div>

      {/* 🔹 View Modal */}
      {selectedQuery && (
        <div className="modal-overlay" onClick={() => setSelectedQuery(null)}>
          <div className="modal-box" onClick={(e) => e.stopPropagation()}>
            <h2>Query Details</h2>
            {/* <p>
              <strong>Name:</strong> {selectedQuery.name}
            </p> */}
            <p>
              <strong>Email:</strong> {selectedQuery.email}
            </p>
            <p>
              <strong>Phone:</strong> {selectedQuery.phone}
            </p>
            <p>
              <strong>Subject:</strong> {selectedQuery.issue}
            </p>
            <p>
              <strong>Message:</strong> {selectedQuery.description}
            </p>

            <button
              className="close-btn"
              onClick={() => setSelectedQuery(null)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactQueries;
